import { useNavigate } from 'react-router-dom';

interface SignupRequiredModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
}

export default function SignupRequiredModal({
  open,
  onClose,
  title = '회원가입이 필요합니다',
  description = '무료 회원가입 후 AI 가 제공하는 댜양한기능을 이용해보세요',
}: SignupRequiredModalProps) {
  const navigate = useNavigate();

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="absolute inset-0 bg-ink-900/60 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative w-full max-w-md bg-white rounded-2xl border border-ink-100 overflow-hidden">
        <div className="p-6 md:p-8 text-center">
          <div className="w-16 h-16 rounded-2xl bg-warm-50 border border-warm-100 flex items-center justify-center mx-auto mb-5">
            <i className="ri-user-add-line text-3xl text-warm-500" />
          </div>
          <h2 className="text-xl font-extrabold text-ink-700 mb-2">
            {title}
          </h2>
          <p className="text-sm text-ink-500 leading-relaxed mb-6 whitespace-pre-line">
            {description}
          </p>
          <button
            onClick={() => navigate('/sign-up')}
            className="w-full px-6 py-3 bg-ink-700 text-white text-sm font-bold rounded-xl hover:bg-ink-600 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-arrow-right-line" />
            간단 회원가입하기
          </button>
          <p className="text-xs text-ink-400 mt-4">
            이미 계정이 있으신가요?{' '}
            <button
              onClick={() => navigate('/sign-in')}
              className="text-warm-600 font-semibold hover:text-warm-700 underline cursor-pointer"
            >
              로그인
            </button>
          </p>
        </div>
        <button
          onClick={onClose}
          className="absolute top-3 right-3 w-8 h-8 rounded-lg flex items-center justify-center text-ink-400 hover:bg-cream-50 hover:text-ink-600 transition-colors cursor-pointer"
          title="닫기"
        >
          <i className="ri-close-line text-lg" />
        </button>
      </div>
    </div>
  );
}